module.exports = __webpack_public_path__ + "static/img/14000474.f795ba0e.png";